import React from 'react';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import { useTheme } from '@material-ui/core/styles';

const reasons = [
  {
    title: 'Mística y cercanía',
    text: 'No es una valla fría: un equipo que se involucra en el crecimiento de la marca y trata a Chemical como aliado, no como anunciante anónimo.',
  },
  {
    title: 'Infraestructura en streaming y On-Demand',
    text: 'La plataforma permite que el plan de negocio se escuche con claridad profesional y que la marca se vea en contextos de estudio y redes, con producción acorde a TNO.',
  },
  {
    title: 'Autoridad en Google',
    text: 'Con TNO Digest, búsquedas como emprender en Venezuela o inversión en limpieza pueden encontrar primero nuestras notas, con enlaces y CTAs hacia Chemical.',
  },
];

const WhyTNO = () => {
  const theme = useTheme();

  return (
    <Box marginBottom={4}>
      <Typography
        sx={{ textTransform: 'uppercase', fontWeight: 'medium' }}
        gutterBottom
        color="primary"
        align="center"
      >
        Plataforma
      </Typography>
      <Typography variant="h4" fontWeight={700} align="center" color="primary" gutterBottom>
        ¿Por qué hacerlo con TNO Network?
      </Typography>
      <Grid container spacing={3}>
        {reasons.map((r, i) => (
          <Grid item xs={12} md={4} key={i}>
            <Box
              sx={{
                p: 2,
                height: '100%',
                borderRadius: 2,
                border: `1px solid ${theme.palette.divider}`,
                bgcolor: theme.palette.mode === 'dark' ? 'action.hover' : 'grey.50',
              }}
              data-aos="fade-up"
              data-aos-delay={i * 80}
            >
              <Typography variant="h6" fontWeight={700} color="primary" gutterBottom>
                {r.title}
              </Typography>
              <Typography variant="body2" color="textSecondary">
                {r.text}
              </Typography>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default WhyTNO;
